import { HTMLAttributes, ImgHTMLAttributes, ReactElement } from "react";
import { SpaceProps } from "styled-system";

export interface WrapperProps extends SpaceProps, HTMLAttributes<HTMLDivElement> {
    width: number;
    height: number;
}

export const variants = {
    DEFAULT: "default",
    INVERTED: "inverted",
  } as const;
  
export type Variant = (typeof variants)[keyof typeof variants];